import {
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ModalService } from '@modules/cotizaciones/services/modal-service';
import { SharedModule } from '@shared/shared.module';
import { SafeUrlPipe } from '@core/pipes/safe-url.pipe';

@Component({
  selector: 'app-modal-detalle-mensajes',
  standalone: true,
  imports: [SharedModule, SafeUrlPipe],
  templateUrl: './modal-detalle-mensajes.component.html',
  styleUrl: './modal-detalle-mensajes.component.scss',
})
export class ModalDetalleMensajesComponent implements OnInit, OnChanges {
  private modalService = inject(ModalService);
  @Input() url: any;

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if(changes['url']){
      this.url = changes['url'].currentValue;
    }
  }

  onClose() {
    this.url = null;
    this.modalService.closeModal('modal-detalle-mensajes');
  }
}
